export const CoreDI = {
	System: Symbol('System'),
	UpdateManager: Symbol('UpdateManager'),
	Device: Symbol('Device'),
	FullscreenManager: Symbol('FullscreenManager'),
	ResolutionManager: Symbol('ResolutionManager'),
	Application: Symbol('PIXI.Application'),
	VisibilityManager: Symbol('VisibilityManager'),
	IAsyncEventManager: Symbol('IAsyncEventManager'),
	IEventManagerWithAsync: Symbol('IEventManagerWithAsync'),
	ResourceLoader: Symbol('ResourceLoader'),
	APIModule: Symbol('APIModule'),
};



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/di/CoreDI.ts